var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-tooltip",
    {
      attrs: {
        content: _vm.$t("pc_biz_eval_add_relation_maxsix"),
        placement: "top",
        disabled: !_vm.disabledFunc,
      },
    },
    [_c("span", [_vm._v(_vm._s(_vm.label))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }